import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  EmissionFactorCsvDataDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EMISSION_FACTORS } from "../domain";

import { emissionFactorsApi } from "@api/services";
import { ACTION_GET_EMISSION_FACTORS, roleGuard } from "@api";

export const ACTION_UPDATE_EMISSION_FACTOR = "UPDATE_EMISSION_FACTOR";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const importEmissionFactorCsv = async (
  csvData: EmissionFactorCsvDataDto[],
): Promise<void> => {
  await emissionFactorsApi.emissionFactorsControllerImportEmissionFactorsCsv(
    csvData,
  );
};

export const useImportEmissionFactorCsv = (
  user: UserProfileDto | null,
): {
  importEmissionFactorCsv: UseMutateFunction<
    void,
    unknown,
    EmissionFactorCsvDataDto[],
    unknown
  >;
  importEmissionFactorCsvEnabled: boolean;
  isSuccessImportEmissionFactorCsv: boolean;
  isPendingImportEmissionFactorCsv: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EMISSION_FACTORS, ACTION_UPDATE_EMISSION_FACTOR],
    mutationFn: enabled ? importEmissionFactorCsv : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_EMISSION_FACTORS, ACTION_GET_EMISSION_FACTORS],
      });
    },
  });

  return {
    importEmissionFactorCsv: mutateAsync,
    importEmissionFactorCsvEnabled: enabled,
    isSuccessImportEmissionFactorCsv: isSuccess,
    isPendingImportEmissionFactorCsv: isPending,
  };
};
